import styled from 'styled-components';
import { SectionContentWrapper as BaseSectionContentWrapper, WhiteCard as BaseWhiteCard, GlassContainer as BaseGlassContainer } from '../About.styles';

export { BaseSectionContentWrapper as SectionContentWrapper, BaseWhiteCard as WhiteCard, BaseGlassContainer as GlassContainer };

export const ContentText = styled.div`
  font-size: 1.1rem;
  color: ${(props) => props.theme.text};
  line-height: 1.6;
  p {
    margin-bottom: 1.5rem;
  }
`;

export const TwoColumnSection = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
  margin: 1.5rem 0;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const MapImage = styled.img`
  width: 500px;
  height: 333px;
  object-fit: cover;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: block;

  &:hover {
    transform: scale(1.02);
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
  }
`;
